// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-wrapper button:nth-child(1) {
  background-color: #c0c0c0;
}
.nav-wrapper button:nth-child(2) {
  background-color: #b0b0b0;
}
.nav-wrapper button:nth-child(3) {
  background-color: #a0a0a0;
}
.nav-wrapper button:nth-child(4) {
  background-color: #909090;
}
.nav-wrapper button:nth-child(5) {
  background-color: #909090;
}

.nav-btn {
  background: linear-gradient(145deg, #d4d7d8, #f0f0f0);
  box-shadow: inset 0 0 5px #ffffff, 0 2px 5px rgba(0,0,0,0.2);
  border: 1px solid #aaa;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
}

.nav-btn:hover {
  opacity: 0.95;
  box-shadow: inset 0 0 8px #ffffff, 0 4px 8px rgba(0,0,0,0.3);
}
`, "",{"version":3,"sources":["webpack://./src/components/NavButtons/NavButtons.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,4DAA4D;EAC5D,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4DAA4D;AAC9D","sourcesContent":[".nav-wrapper button:nth-child(1) {\n  background-color: #c0c0c0;\n}\n.nav-wrapper button:nth-child(2) {\n  background-color: #b0b0b0;\n}\n.nav-wrapper button:nth-child(3) {\n  background-color: #a0a0a0;\n}\n.nav-wrapper button:nth-child(4) {\n  background-color: #909090;\n}\n.nav-wrapper button:nth-child(5) {\n  background-color: #909090;\n}\n\n.nav-btn {\n  background: linear-gradient(145deg, #d4d7d8, #f0f0f0);\n  box-shadow: inset 0 0 5px #ffffff, 0 2px 5px rgba(0,0,0,0.2);\n  border: 1px solid #aaa;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: all 0.3s ease;\n}\n\n.nav-btn:hover {\n  opacity: 0.95;\n  box-shadow: inset 0 0 8px #ffffff, 0 4px 8px rgba(0,0,0,0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
